import { Button, Modal, Result, Typography } from "antd";

interface Props {
  open: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
  /** Rendered bold after the message, e.g. the document acted on. */
  highlight?: string;
}

/**
 * "Sent Successful !" confirmation.
 *
 * Built on antd <Result status="success"> — the same primitive the shared
 * Components/SuccessModal wraps — but closable and without that component's
 * mandatory redirect/reTrigger coupling, which does not apply here.
 */
export const SentSuccessModal = ({
  open,
  onClose,
  title = "Sent Successful !",
  message = "Details Email has Sent Successfully.",
  highlight,
}: Props) => (
  <Modal
    open={open}
    onCancel={onClose}
    footer={null}
    centered
    width={420}
    maskClosable={false}
  >
    <Result
      status="success"
      title={title}
      subTitle={
        highlight ? (
          <>
            {message} <Typography.Text strong>{highlight}</Typography.Text>
          </>
        ) : (
          message
        )
      }
      extra={
        <Button
          type="primary"
          onClick={onClose}
        >
          Ok
        </Button>
      }
    />
  </Modal>
);
